import React from 'react';
import type { LucideIcon } from 'lucide-react';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  action?: React.ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({ icon: Icon, title, description, action }) => (
  <div className="flex flex-col items-center justify-center py-14 px-6 text-center">
    <div
      aria-hidden
      className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-brand-accent/10 ring-1 ring-brand-accent/20"
    >
      <Icon className="h-6 w-6 text-brand-primary" strokeWidth={1.5} />
    </div>
    <h3 className="text-sm font-semibold text-brand-text">{title}</h3>
    {description && (
      <p className="mt-1 text-sm text-brand-text-muted max-w-sm">{description}</p>
    )}
    {action && <div className="mt-5">{action}</div>}
  </div>
);

export default EmptyState;
